import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import {
  AiScreeningResponseStatus,
  AiScreeningResult,
  AiScreeningsResponse,
} from '@core/ai-screening-types';
import { TranslatePipe } from '@core/i18n-legacy';
import type { TOfferKind, TOfferStatus } from '@core/offers-types';
import { OfferStatusIndicatorComponent } from '@core/offers-ui';
import {
  BadgeComponent,
  CollapsibleCardComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';
import {
  AiScreeningResultsListComponent,
  ScreeningIconComponent,
} from '@recruitee/ai-screening-ui';
import { getScreeningSummaryData } from '@recruitee/ai-screening-util';

export interface ScreeningOffer {
  id: number;
  title: string;
  kind: TOfferKind;
  status: TOfferStatus;
}

@Component({
  selector: 'rt-screening-result-card',
  templateUrl: './screening-result-card.component.html',
  styleUrl: './screening-result-card.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CollapsibleCardComponent,
    HeadingComponent,
    IconComponent,
    ScreeningIconComponent,
    TranslatePipe,
    OfferStatusIndicatorComponent,
    DividerComponent,
    RtTooltip,
    TruncateComponent,
    AiScreeningResultsListComponent,
    BadgeComponent,
  ],
})
export class ScreeningResultCardComponent {
  public screening = input.required<AiScreeningsResponse>();
  public disableEdit = input(false);
  public offer = input<ScreeningOffer | null>();
  public initialCollapsed = input(true);
  public hasNewBadge = input(false);

  public edit = output<AiScreeningResult>();

  protected screeningSummaryData = computed(() =>
    getScreeningSummaryData(this.screening().results, this.screening().status),
  );
  protected forceCollapsed = computed(() =>
    (<AiScreeningResponseStatus[]>['failed', 'pending', 'in_progress']).includes(
      this.screeningSummaryData().screeningStatus,
    ),
  );
}
